import { useEffect } from 'react';
// 1. Сначала базовые стили библиотеки (обязательно!)
import 'vanilla-cookieconsent/dist/cookieconsent.css';
// 2. Потом ТВОИ стили (они переопределят базовые)
import '../../styles/cookie-consent.css'; // <--- Проверь путь к файлу!

import * as CookieConsent from 'vanilla-cookieconsent';

import { useTranslation } from 'react-i18next';

const CookieConsentConfig = () => {
    const { i18n } = useTranslation();

    useEffect(() => {
        // Включаем встроенный Dark Mode
        // document.documentElement.classList.add('cc--darkmode');

        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: "box",
                    position: "bottom left",
                    equalWeightButtons: true,
                    flipButtons: false
                },
                preferencesModal: {
                    layout: "bar", // Твой выбор из конструктора
                    position: "left",   // Твой выбор
                    equalWeightButtons: true,
                    flipButtons: true
                }
            },
            categories: {
                necessary: {
                    readOnly: true
                },
                analytics: {},
                marketing: {}, // Добавил, как в твоем примере
                social: {}
            },
            language: {
                default: "en",
                autoDetect: "document",

                translations: {
                    // --- ENGLISH (Твой конфиг + ссылки) ---
                    en: {
                        consentModal: {
                            title: "🍪 Cookie Preferences",
                            description: "We use cookies to ensure the best experience, understand how the site is used, and support basic functionality. You can choose to accept all cookies or adjust your settings.",
                            closeIconLabel: "",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            showPreferencesBtn: "Manage preferences",
                            // ССЫЛКИ ЗДЕСЬ: Замени href на реальные пути
                            footer: `
                                <a href="/privacy" target="_blank">Privacy Policy</a>
                                <a href="/terms" target="_blank">Terms and conditions</a>
                            `
                        },
                        preferencesModal: {
                            title: "Consent Preferences Center",
                            closeIconLabel: "Close modal",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            savePreferencesBtn: "Save preferences",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookie Usage",
                                    description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience."
                                },
                                {
                                    title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                                    description: "These cookies are essential for the proper functioning of the website.",
                                    linkedCategory: "necessary"
                                },
                                {
                                    title: "Analytics Cookies",
                                    description: "These cookies collect information about how you use our website.",
                                    linkedCategory: "analytics"
                                },
                                {
                                    title: "Advertisement Cookies",
                                    description: "These cookies are used to make advertising messages more relevant to you.",
                                    linkedCategory: "marketing"
                                },
                                {
                                    title: "More information",
                                    description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href=\"/contact\">contact us</a>."
                                }
                            ]
                        }
                    },

                    // --- RUSSIAN (Для примера, чтобы не потерял) ---
                    ru: {
                        consentModal: {
                            title: "🍪 Настройки Cookie",
                            description: "Мы используем файлы cookie для улучшения работы сайта.",
                            acceptAllBtn: "Принять все",
                            acceptNecessaryBtn: "Отклонить все",
                            showPreferencesBtn: "Настройки",
                            footer: `
                                <a href="/privacy" target="_blank">Политика конфиденциальности</a>
                                <a href="/terms" target="_blank">Условия использования</a>
                            `
                        },
                        preferencesModal: {
                            title: "Настройки согласия",
                            savePreferencesBtn: "Сохранить",
                            acceptAllBtn: "Принять все",
                            acceptNecessaryBtn: "Отклонить все",
                            sections: [
                                { title: "Использование Cookie", description: "Мы используем cookie для работы сайта." },
                                { title: "Необходимые", description: "Эти файлы нужны для работы сайта.", linkedCategory: "necessary" },
                                { title: "Аналитика", description: "Помогают нам понять, как вы используете сайт.", linkedCategory: "analytics" },
                                { title: "Маркетинг", description: "Используются для рекламы.", linkedCategory: "marketing" }
                            ]
                        }
                    },

                    // Сюда можно добавить другие языки (sl, es...) по аналогии
                }
            },

            // Блокировка контента и затемнение
            disablePageInteraction: true,

            onConsent: () => {
                if(CookieConsent.acceptedCategory('analytics')){
                    enableAnalytics();
                }
            },

            onChange: ({ changedCategories }: any) => {
                if(changedCategories.includes('analytics')){
                    if(CookieConsent.acceptedCategory('analytics')){
                        enableAnalytics();
                    } else {
                        window.location.reload();
                    }
                }
            }
        });
    }, []);

    useEffect(() => {
        CookieConsent.setLanguage(i18n.language);
    }, [i18n.language]);

    const enableAnalytics = () => {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        function gtag(){dataLayer.push(arguments);}
        // @ts-ignore
        gtag('js', new Date());
        // @ts-ignore
        gtag('config', 'G-XXXXXXXXXX');
        console.log("Analytics enabled");
    };

    return null;
};

export default CookieConsentConfig;
